import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface AgeDistribution {
  result: Array<{
    count: number;
    ageGroup: string;
  }>;
  totalCount: number;
}

export const getAgeDistributionAPI = async (studioId: string) => {
  const response = await baseAPI.get<AgeDistribution>(
    `/dashboard/students-distribution/age/${studioId}`,
  );
  return response.data;
};

export const useGetAgeDistribution = (studioId?: string) => {
  return useQuery({
    queryKey: [KEYS.AGE_DISTRIBUTION, studioId],
    queryFn: () => {
      if (!studioId) {
        throw new Error('Studio ID is required');
      }
      return getAgeDistributionAPI(studioId);
    },
    enabled: !!studioId,
  });
};
